const CONSTANTS = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || "",
  NODE_ENV: import.meta.env.VITE_NODE_ENV,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,
  REDIRECT_URL: import.meta.env.VITE_REDIRECT_URL as string,
  APP_NAME: import.meta.env.VITE_APP_NAME,
  SEE_LOGS: import.meta.env.VITE_SEE_LOGS,
  DEV_TIMEOUT: import.meta.env.VITE_DEV_TIMEOUT,
};

/**
 * Version affichée (`vX.Y.Z`).
 * Source : `VITE_APP_VERSION` injectée au build (`.env*` puis `package.json`,
 * voir `vite.config.ts`).
 */
export function getDisplayAppVersion(): string {
  const raw = (CONSTANTS.APP_VERSION ?? "").trim();
  if (!raw) return "";
  return raw.startsWith("v") ? raw : `v${raw}`;
}

export { CONSTANTS };
